const TOKEN_REGEX = /^[A-Za-z0-9-_=]+\.[A-Za-z0-9-_=]+\.?[A-Za-z0-9-_.+/=]*$/
export class Token {
  private _token: string

  constructor (token: string) {
    if (TOKEN_REGEX.test(token) === false) {
      throw new TypeError('Token provided format not valid')
    }
    this._token = token
  }

  token (): string {
    return this._token
  }
}
